import {
	AMB_GC,
	GARBAGE_COLLECTOR_INTERVAL,
	TIME_TO_WAIT_AFTER_DISCONNECT,
	GQL_CACHE_CAPACITY,
	GQL_CACHING_ENABLED,
	GQL_CACHING_REFRESH_DELAY,
	HTTP_CACHING_REFRESH_DELAY,
	HTTP_CACHE_CAPACITY,
	HTTP_CACHING_ENABLED,
	CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS,
	LOGGING_ENABLED,
	LOGGING_LEVELS,
	LOGS_OBSERVER_INTERVAL,
	VALIDATE_SCHEMAS,
	ENABLE_SCHEDULER_STATS,
	METRICS_COMPONENT_INTERACTIVE_ENABLED,
	ARIA_LIVE_ASSERTIVE_TIMEOUT,
	ARIA_LIVE_POLITE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_THROTTLE,
	WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL,
	METRICS_OBSERVER_INTERVAL,
	SCHEDULER_RAF_TIMEOUT,
	METRICS_MARK_PRUNING_INTERVAL,
	METRICS_MARK_EXPIRATION,
	METRICS_PRUNE_MARKS
} from '../constants';

export const devConfig = {};

// AMB GC
devConfig[AMB_GC] = {};
devConfig[AMB_GC][GARBAGE_COLLECTOR_INTERVAL] = 20000;
devConfig[AMB_GC][TIME_TO_WAIT_AFTER_DISCONNECT] = 5000;

// Caching
devConfig[GQL_CACHING_ENABLED] = true;
devConfig[GQL_CACHING_REFRESH_DELAY] = 500;
devConfig[GQL_CACHE_CAPACITY] = 3;
devConfig[HTTP_CACHING_ENABLED] = true;
devConfig[HTTP_CACHE_CAPACITY] = 3;
devConfig[HTTP_CACHING_REFRESH_DELAY] = 500;

// Logging
devConfig[LOGGING_ENABLED] = true;
devConfig[LOGGING_LEVELS] = true;
devConfig[LOGS_OBSERVER_INTERVAL] = 1000;

// Validation
devConfig[VALIDATE_SCHEMAS] = true;
devConfig[CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS] = true;

devConfig[ENABLE_SCHEDULER_STATS] = true;

devConfig[METRICS_COMPONENT_INTERACTIVE_ENABLED] = true;

devConfig[ARIA_LIVE_ASSERTIVE_TIMEOUT] = 500;
devConfig[ARIA_LIVE_POLITE_TIMEOUT] = 5000;

devConfig[WHEN_COMPONENT_IS_IDLE_TIMEOUT] = 5000;
devConfig[WHEN_COMPONENT_IS_IDLE_THROTTLE] = 50;
devConfig[WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL] = 25;

devConfig[METRICS_OBSERVER_INTERVAL] = 3000;
devConfig[SCHEDULER_RAF_TIMEOUT] = 0;

devConfig[METRICS_MARK_PRUNING_INTERVAL] = 300000;
devConfig[METRICS_MARK_EXPIRATION] = 300000;
devConfig[METRICS_PRUNE_MARKS] = true;
